export default __webpack_public_path__ + "static/media/drregula.55e10df1.jpeg";